import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { InvoicesService } from '../_services/invoices.service';
import { ParameterData, CustomValidators } from '../_helpers/index';
import { Router } from '@angular/router';
import { DataService } from '../_helpers/dataservice.service'
import { Invoice, Account, Debtor } from '../_models';
import { CustomerService } from '../_services';
import { currencysymbolPrefix } from '../_enums/debtordocumenttype';

import { AuthService } from '../_services/auth.service';
import { AccountTypeOptions } from '../sharedcomp/constans/routes.constans';

@Component({
    selector: 'salesinvoicecreate',
    templateUrl: './salesinvoicecreate.component.html'


})
export class SalesInvoiceCreateComponent {

    public customer_public_id: string;
    public user_public_id: string;

    public invoicePublic_key: any;
    public cusAccountPublicKey_temp: Account[] = [];
    public cusAccountPublicKey_ntemp: Account[] = [];
    public cusDebtor: Debtor[] = [];
    public invoiceForm: FormGroup;
    public duedatetime: string;
    submitted = false;
    due_datetime: any;
    ddltotalCurrencySymbol: any[];
    ddlLatefeeCurrencySymbol: any[];
    statusValue: any;
    debPublicID: string;
    isalertVisiable = false;
    auth0Profile: any;


    constructor
        (
            private router: Router, private _fb: FormBuilder
            , private parameterData: ParameterData, private dataService: DataService
            , private invoicesService: InvoicesService, private customerService: CustomerService
            , private _currencysymbolPrefix: currencysymbolPrefix
            , private auth: AuthService

        ) {


        //this is used to get the Invoice key comes from service; if public key is empty then default key will be asigned.
        if (this.parameterData.DebtorIdParameters !== null) {
            this.debPublicID = this.parameterData.DebtorIdParameters;
            this.parameterData.DebtorIdParameters = null;
        }
        else {
            this.debPublicID = "Seleccione";
        }



        this.isalertVisiable = false;

        this.ddltotalCurrencySymbol = _currencysymbolPrefix.currencyPrefix;
        this.ddlLatefeeCurrencySymbol = _currencysymbolPrefix.currencyPrefix;



        this.dataService.currentInvoicePublicKey.subscribe((data) => {
            this.invoicePublic_key = data;
        });



        this.InitialSetup();


    }//end 


    InitialSetup() {

        var currentDueDate = new Date();
        var currentExpDate = new Date();
        var currentDate = new Date();
        currentDueDate.setDate(currentDueDate.getDate() + 15);

        this.duedatetime = currentDueDate.toString();


        this.invoiceForm = this._fb.group({
            invoice_id: new FormControl(""),
            metadata: this._fb.group({
                order_id: new FormControl(""),
                order_name: new FormControl("", Validators.required),
                order_description: new FormControl(""),
                tipoDe: new FormControl("")
            }),
            debtor: this._fb.group({
                public_id: new FormControl(this.debPublicID, Validators.required)
            }),
            total: this._fb.group({
                currency: new FormControl("Seleccione", Validators.required),
                value: new FormControl(0, [Validators.required, CustomValidators.total])
            }),


            terminos: new FormControl(""),
            create_datetime: new FormControl(new Date(currentDate)),
            due_datetime: new FormControl(new Date(currentDueDate)),
            late_fee: this._fb.group({
                currency: new FormControl("Seleccione", Validators.required),
                value: new FormControl(0, [Validators.required])
            }),

            expiration_datetime: new FormControl(new Date(currentExpDate.setDate(currentExpDate.getDate() + 30))),
            //    

            creditor_account: this._fb.group({
                public_id: new FormControl("")
            }),
            user: this._fb.group({
                public_id: new FormControl("")
            })

        });
    }

    onDueDateChange(_event) {
        this.duedatetime = _event;
    }

    GetDebtorDetails() {

        this.customerService.getCustomerDebtorsList(this.customer_public_id).subscribe(data => {
            let resources = data["data"];
            this.cusDebtor = resources;

        },
            error => {
                console.log('Failed while trying to the Debtor Details. ' + error);
            });
    }//end


    ngOnInit() {


        let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
        if (browserStorage1 == null) {
            let browserStorage = localStorage.getItem('companyId');
            if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
                this.router.navigate(['/home']);
            }
            else {
                this.customer_public_id = localStorage.getItem('companyId');
                this.user_public_id = localStorage.getItem('userId');

            }
        }
        else {
            this.customer_public_id = localStorage.getItem('subcompanyId');
            this.user_public_id = localStorage.getItem('userId');
        }



        setTimeout(() => {
            this.customerService.getCustomerAccountList(this.customer_public_id).subscribe(data => {
                this.cusAccountPublicKey_temp = data;

                this.cusAccountPublicKey_temp = this.cusAccountPublicKey_temp.filter((t => t.type == 'COLLECT' || t.type == 'RECEIVABLE'));

                if (this.cusAccountPublicKey_temp != undefined) {
                    this.invoiceForm.get('total.currency').setValue(this.cusAccountPublicKey_temp[0].balance.currency);
                    this.invoiceForm.get('late_fee.currency').setValue(this.cusAccountPublicKey_temp[0].balance.currency);
                }
            });
        }, 500);
        this.GetDebtorDetails();


    }//end

    ngOnDestroy() {
        this.dataService.changeinvoicepublicKey('invoice Key');
    }


    checkCurrencyDetails(value) {

        if (this.invoiceForm.get('total.currency').value != value) {
            alert("Please select the Currency same Mora and Monto")
        }
        
    }

    onsubmit(event, { value }: { value: Invoice }) {


        this.cusAccountPublicKey_ntemp = this.cusAccountPublicKey_temp.filter((t => t.balance.currency == value.total.currency));

        value.creditor_account.public_id = this.cusAccountPublicKey_ntemp[0].public_id;
        value.invoice_id = value.metadata.order_id;
        if (value.total.currency == 'S/.') {
            value.late_fee.currency = 'PEN';
            value.late_fee.value = Number(value.late_fee.value);
            value.total.currency = 'PEN';
            value.total.value = Number(value.total.value);
        }

        if (value.total.currency == 'US$') {
            value.late_fee.currency = 'USD';
            value.late_fee.value = Number(value.late_fee.value);
            value.total.currency = 'USD';
            value.total.value = Number(value.total.value);
        }
        value.late_fee.value = Number(value.late_fee.value);
        value.total.value = Number(value.total.value);

        value.user.public_id = this.user_public_id;


        if (value.id === null) {
            value.id = 0;
        }



        if (value.total.currency == value.late_fee.currency) {


            this.invoicesService.createInvoice(value)
                .subscribe((result) => {

                    this.invoiceForm.reset();
                    this.statusValue = "La información fue creada correctamente !";
                    this.isalertVisiable = true;

                    this.viewInvoiceDetail(result.public_id);

                }, error => {
                    console.log('Failed while trying to create the Invoice Details.' + error);
                });
        }
        else {
            this.statusValue = "Please select the Currency same Mora and Monto!";
            this.isalertVisiable = true;
        }

    }

    viewInvoiceDetail(id) {

        const application = localStorage.getItem('application');
        if (AccountTypeOptions[application] != undefined) {
            this.router.navigate([`/${AccountTypeOptions[application]}/invoices/${id}/view`]);
        }
    }

    viewInvoiceList() {
        const application = localStorage.getItem('application');
        if (AccountTypeOptions[application] != undefined) {
            this.router.navigate([`/${AccountTypeOptions[application]}/invoices`]);
        }
    }

}//end

